// Generated by purs version 0.15.4
var emptyRouteState = {
    segments: [  ],
    params: [  ],
    hash: ""
};
export {
    emptyRouteState
};
